<div class="modal-content">

    <div class="modal-header">
        <h4>{{'COMPOSEMESSAGE'|translate}}</h4>
    </div>
    <div class="card" style="height: 100% !important">
        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <!-- [(ngModel)]="MailObj.from"  -->
                    <sanabel-selectize appcode="1020" [smallInput]="true" placeholder="from" [simpleView]="true"
                        (clicked)="onEmpClicked($event)" name="from">
                    </sanabel-selectize>
                </div>
            </div>
            <div class="col-4">
                <div class="form-group">
                    <label>{{'RECEIVERNAME'|translate}}</label> {{toEmailAddress}}
                    <!-- <input type="text" class="form-control" placeholder="Subject" [(ngModel)]="MailObj.subject" name="subject"> -->
                </div>
            </div>
            <div class="col-3">
                <div class="form-group">
                    <label>{{'SENDERNAME'|translate}}</label> {{this.MailObj.from}}
                    <!-- <input type="text" class="form-control" placeholder="Subject" [(ngModel)]="MailObj.subject" name="subject"> -->
                </div>
            </div>

        </div>

        <div class="row">
            <div class="col-4">
                <div class="form-group">
                    <label>{{'SUBJECT'|translate}}</label>
                    <input type="text" class="form-control" placeholder="{{'SUBJECT'|translate}}"
                        [(ngModel)]="MailObj.subject" name="subject">
                </div>
            </div>
            <div class="col">
                <div class="form-group">
                    <label>{{'EMAILBODY'|translate}}</label>
                    <textarea rows="10" cols="50" type="text" class="form-control"
                        placeholder="{{'EMAILBODY'|translate}}" [(ngModel)]="MailObj.emailBody" name="emailBody">
          </textarea>
                </div>
            </div>
        </div>




    </div>
    <div class="card row" style=" text-align: center; display: inline; margin: 2px;">
        <button style="margin: 1px;" type="button" class="btn width-200 btn-success" (click)="saveFile()"><i
                class="fa fa-television mr-2"></i>
            {{'DISPLAY'|translate}}</button>

        <button style="margin: 1px;" type="button" class="btn width-200 btn-primary" (click)="sentMail()"><i
                class="fa fa-send mr-2"></i>
            {{'SEND'|translate}}</button>
    </div>

    <!-- <ckeditor debounce="300" [(ngModel)]="MailObj.htmlContent" name="htmlContent">
    </ckeditor> -->
    <editor [(ngModel)]="MailObj.htmlContent" name="htmlContent" [init]="editorConfig"></editor>

</div>




<div #contentHtml [hidden]="hideen == 1">


    <!DOCTYPE html>
    <html>

    <head>
        <style>
            table {
                font-family: arial, sans-serif;
                border-collapse: collapse;
                width: 100%;
            }

            td,
            th {
                border: 1px solid #dddddd;
                text-align: left;
                padding: 8px;
            }

            tr:nth-child(even) {
                background-color: #dddddd;
            }
        </style>
    </head>

    <body>

        <h2>
            <span *ngIf="poType !=2">Po.Order</span>
            <span *ngIf="poType ==2">Po.Offer</span> - {{MailObj.subject}}
        </h2>
        <table style="width:100%;text-align: center;">
            <tr>
                <th><strong style="text-decoration: underline;">{{'CODE' | translate}}</strong></th>
                <th *ngIf="poType !=2"><strong style="text-decoration: underline;">{{'POORDERSUPPLYDATE' |
                        translate}}</strong>
                </th>
                <th *ngIf="poType ==2"><strong style="text-decoration: underline;">{{'POOFFERSUPPLYDATE' |
                        translate}}</strong>
                </th>
                <th><strong style="text-decoration: underline;">{{'SUPPLIER' | translate}}</strong></th>
            </tr>
            <tr>
                <td>{{row?.serial}}</td>
                <td>{{ row?.regDate | date :'short' }}</td>
                <td>{{translate.currentLang == 'ar' ? row?.nameAr : row?.nameEn}}</td>
            </tr>
        </table>
        <hr>

        <table style="width:100%;text-align: center;">
            <tr>
                <td class="groupHeaderLevel1_ar">{{'UNIT' | translate}}</td>
                <td class="groupHeaderLevel1_ar">{{'QTYNEEDED' | translate}}</td>
                <td class="groupHeaderLevel1_ar">{{'ITEMNAME' | translate}}</td>
                <td class="groupHeaderLevel1_ar">{{'ITEMCODE' | translate}}</td>
            </tr>
            <tbody>
                <tr *ngFor="let item of items" style="text-align: center;">
                    <td class="detailBand_ar">{{translate.currentLang == 'ar' ? item.unitNameAr : item.unitNameEn}}</td>
                    <td class="detailBand_ar">{{item.quantity}}</td>
                    <td class="detailBand_ar">{{translate.currentLang == 'ar' ? item.nameAr : item.nameEn}}</td>
                    <td class="detailBand_ar">{{item.code}}</td>
                </tr>
                <tr>
                    <td colspan="8"></td>
                </tr>
            </tbody>

        </table>

    </body>

    </html>

</div>

<div [hidden]="hideen == 1">
    <po-order-supply-print #contentPrint>

    </po-order-supply-print>
</div>
<div [hidden]="hideen == 1">
    <offers-needed-print #OffercontentPrint>

    </offers-needed-print>
</div>